
// $('.product-image-thumbnail img').click(function(){
//   	$('.product-image-thumbnail').removeClass('active');
//     $(this).parent().addClass('active');
//     var srcLarge = $(this).attr('src');
  
//     console.log(srcLarge);
  
//     $(this).closest('.product-page-v2__gallery').find('.featured').attr('src',$(this).attr('src').replace('thumb','large'));
// });

$(document).ready(function(){
  $('#product-zoomable-image')
    .wrap('<span style="display:block;"></span>')
    .css('display', 'block')
    .parent()
    .zoom();
});

$(document).ready(function(){
$('.product-image-thumbnail img').click(function(event) {        // change image shown as product image
    var newImageUrl = $(this).attr('src');
    $('.product-image-thumbnail').removeClass('active');
    $(this).parent().addClass('active');
    console.log(newImageUrl)    ;
    $('#product-zoomable-image').attr('src', newImageUrl);
    $('#product-zoomable-image').trigger('zoom.destroy');
    $('#product-zoomable-image').parent().zoom({url: newImageUrl});
});
});

jQuery(function(){
  var j = jQuery; //Just a variable for using jQuery without conflicts
  var addInput = '.product-pricing-block__quant'; //This is the id of the input you are changing
  var n = 1; //n is equal to 1
  
  //Set default value to n (n = 1)
  j(addInput).val(n);

  //On click add 1 to n
  j('.product-pricing-block__quant__plus').on('click', function(){
    j(addInput).val(++n);
  })

  j('.product-pricing-block__quant__minus').on('click', function(){
    //If n is bigger or equal to 1 subtract 1 from n
    if (n >= 1) {
      j(addInput).val(--n);
    } else {
      //Otherwise do nothing
    }
  });
});



$('.featured-collection-slider__slider').slick({
  dots: false,
  speed: 300,
  slidesToShow: 4.7,
  slidesToScroll: 1,
  centerMode: true,
  infinite: true,
  nextArrow: $('.featured-collection-slider__slider-arrow'),
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2.7,
        slidesToScroll: 1,
        infinite: true,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
  		infinite: true,
        centerPadding: '17%'
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
  		infinite: true,
        centerPadding: '17%'
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

$('.js-quotes').slick({
  dots: true,
  speed: 500,
  slidesToShow:1,
  slidesToScroll: 1,
  infinite: true,
  autoplay: true,
  centerMode: true,
  centerPadding: '20%',
  responsive: [
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
  		infinite: true,
        centerPadding: '0'
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

$('.awards').slick({
  dots: false,
  speed: 300,
  slidesToShow: 3.7,
  slidesToScroll: 1,
  centerMode: true,
  infinite: true,
  nextArrow: $('.featured-collection-slider__slider-arrow'),
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2.7,
        slidesToScroll: 1,
        infinite: true,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
  		infinite: true,
        centerPadding: '0'
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
  		infinite: true,
        centerPadding: '0'
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

$(document).ready(function() {
  setTimeout(function() {
    $('.featured-recommendation-slider__slider').slick({
      dots: false,
      speed: 300,
      slidesToShow: 3.7,
      slidesToScroll: 1,
      centerMode: true,
      infinite: true,
      nextArrow: $('.featured-collection-slider__slider-arrow'),
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2.7,
            slidesToScroll: 1,
            infinite: true,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            infinite: true,
            centerPadding: '17%'
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            infinite: true,
            centerPadding: '17%'
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });

  }, 3000);
});

$('.pages-slider').slick({
  dots: false,
  speed: 300,
  slidesToShow: 3.7,
  slidesToScroll: 1,
  centerMode: true,
  infinite: true,
  nextArrow: $('.pages-slider__slider-arrow'),
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2.7,
        slidesToScroll: 1,
        infinite: true,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        dots: true,
  		infinite: true,
        centerPadding: '10%'
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        centerMode: true,
  		infinite: true,
        centerPadding: '10%'
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

if ($(window).width() < 1150) {
   $('.footer__links__heading').on('click', function() {
      $(this).next().slideToggle();
      $(this).toggleClass('active');
   });
  
  $('.product-hero__images').slick({
    dots: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    infinite: true,
  });
  
  $('.product-specificiations__nutritional__head').on('click', function() {
    $(this).toggleClass('active');
    $(this).next().slideToggle();
  });
  
  $('.product-specificiations__ingredients h3').on('click', function() {
    $(this).toggleClass('active');
    $(this).next().slideToggle();
  });
  
  
}


$('.js-imageSlide').slick({
  prevArrow: $('.js-recipe-prev'),
  nextArrow: $('.js-recipe-next'),
  fade: true
});

$('.delay-notification__close').on('click', function() {
    $('.delay-notification-wrap').toggle();
  });

//     $(this).next().slideToggle();
//     $(this).find('.accordion__read-js').text($('.accordion__read-js').text() == 'Read Less' ? 'Read More':'Read Less');
//     $('.accordion__read-img').toggleClass('active');

$(document).ready(function(){
//   $('.accordion__title').on('click', function(){
//     $(this).nextAll('.accordion__content').slideToggle();
//     $(this).find('.accordion-icon').toggleClass('active');
//   })
  $('.accordion__content-wrap').on('click', function(){
    $(this).next().slideToggle();
    $(this).find('.accordion-icon').toggleClass('active');
  })
})


var selectId = document.getElementById("SortBy");

if(document.getElementById('SortBy') != null || 
   document.getElementById('SortBy') != undefined) {
   changeWidth();

  selectId.onchange=function(){
	changeWidth();
}

function changeWidth(){
	var selectedValue = selectId.options[selectId.selectedIndex].value; 
	var selectedText = selectId.options[selectId.selectedIndex].text;
  
	selectId.style.width = 20 + (selectedText.length * 8 + 20) + "px";
}
}